<template>
  <div class="c-personal-tab">
    <div class="c-profile-cards__card tile">
      <div class="c-profile-cards__inputs">
        <div class="c-profile-cards__card__input">
          <Input
            v-model="attributes.first_name"
            :label="$t('Nome')"
            labelColor="#8a8497"
            primary
          />
        </div>
        <div class="c-profile-cards__card__input">
          <Input
            v-model="attributes.last_name"
            :label="$t('Cognome')"
            labelColor="#8a8497"
            primary
          />
        </div>
      </div>
      <div class="c-profile-cards__inputs">
        <div class="c-profile-cards__card__input">
          <Datepicker
            v-model="attributes.birthday"
            swiper
            :label="$t('Data di nascita')"
          />
        </div>
        <div
          class="c-profile-cards__card__input c-profile-cards__card__input--select"
        >
          <Select
            v-model="attributes.gender"
            :label="$t('Sesso')"
            labelColor="#8a8497"
            standard
            primary
            :options="genderOptions"
          />
        </div>
      </div>
      <div class="c-profile-cards__actions">
        <button class="btn c-profile-cards__log-out primary" @click="logout">
          <span v-html="logOutIcon"></span>
          <span class="c-profile-cards__log-out__text">{{ $t("Logout") }}</span>
        </button>
        <div class="btn-wrapper">
          <button
            class="btn btn-primary c-profile-cards__save"
            v-if="attributesAreSame"
            @click="saveUserAttributes"
          >
            {{ $t("Aggiorna") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "../common/Inputs/Input";
import Select from "../common/Inputs/Select";
import Datepicker from "./Datepicker";

import logOutIcon from "@/assets/svg/new/exit-log-out-1.svg";
import supportIcon from "@/assets/svg/new/support.svg";

import { mapGetters } from "vuex";
import _ from "lodash";
import { GlobalService } from "@/common/services/api.service.js";
import { Mutations } from "@/store/global/global.types.js";

export default {
  name: "PersonalTab",
  components: { Input, Select, Datepicker },
  computed: {
    ...mapGetters(["isMobile", "isTablet", "isDesktop", "getUser", "campaign"]),
    attributesAreSame() {
      return !_.isEqual(this.attributes, this.attributesFromBE);
    }
  },
  data() {
    return {
      genderOptions: [
        { text: this.$i18n.t("Maschio"), value: "male" },
        { text: this.$i18n.t("Femmina"), value: "female" },
        { text: this.$i18n.t("Altro"), value: "other" }
      ],
      supportIcon,
      logOutIcon,
      attributes: {
        first_name: "",
        last_name: "",
        birthday: "",
        gender: ""
      },
      attributesFromBE: {}
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    async saveUserAttributes() {
      this.$store.commit(Mutations.SHOW_SPINNER);
      try {
        await GlobalService.updateProfileAttributes(this.attributes);
      } catch (e) {
        let errorResponse = _.get(e, "response", 0);
        switch (errorResponse.status) {
          case 422:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("Dati non validi"),
              text: this.$i18n.t(
                "Controlla il formato dei dati inseriti e riprova"
              )
            });
            break;
          default:
            this.$store.commit("pushMessage", {
              type: "error",
              title: this.$i18n.t("Errore"),
              text: this.$i18n.t("Si è verificato un errore")
            });
            break;
        }
      }
      this.$store.commit(Mutations.HIDE_SPINNER);
    }
  },
  watch: {
    getUser: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.id) {
          const {
            first_name,
            last_name,
            birthday,
            gender
          } = this.getUser.profile;
          this.attributes = { first_name, last_name, birthday, gender };
          this.attributesFromBE = { first_name, last_name, birthday, gender };
        }
      }
    }
  }
};
</script>

<style lang="scss">
.c-profile-cards__card__input--select {
  .c-input {
    @media (min-width: 992px) {
      width: 110px;
    }
  }

  .c-input__label,
  .c-input__input {
    cursor: pointer;
  }
}
</style>
